import React from "react";
import {
  localStorageUserKey,
  renderUserName,
  roles,
} from "../../utils/constants";
import { http, setAuthorizationHeader } from "../api/http";
import { notification } from "antd";
import jwt_decode from "jwt-decode";
import { router } from "../router/AppRouter";

const defaultContext = {};

export const UserContext = React.createContext(defaultContext);

const initialState = {
  isConnected: false,
  appReady: false,
  conf: null,
  user: {
    role: roles.ghost,
    subRoles: [],
    type: "user",
  },
};

export class UserProvider extends React.Component {
  async componentDidMount() {
    await this.getConfDb();
    await this.authLocalUser();
  }

  getConfDb = async () => {
    try {
      const response = await http.get(`conf`, {});
      this.setState({ conf: response.data });
    } catch (e) {
      console.log(e);
    }
  };

  authLocalUser = async () => {
    try {
      const token = localStorage.getItem(localStorageUserKey);
      if (token !== null) {
        // invalid token
        var decoded = jwt_decode(token);

        setAuthorizationHeader(token, this.logoutUser);

        const response = await http.get(`users/${decoded._id}/localstorage`);

        //if (true) {
        if (response.status === 200) {
          this.setState({
            token,
            // user: {
            //   _id: Math.random(),
            //   role: roles.institution,
            //   subRoles: [subRoles.institutionDemander, subRoles.institutionFinance],
            // },
            user: response.data,
            isConnected: true,
            appReady: true,
          });
        }
      } else {
        this.setState({
          appReady: true,
        });
      }
    } catch (e) {
      delete http.defaults.headers.common.Authorization;
    }
  };

  logUser = async (email, pwd) => {
    try {
      const response = await http.post(`auth/login`, {
        email: email.trim(),
        password: pwd,
      });

      await localStorage.setItem(localStorageUserKey, response.data.user.token);

      const { user } = response.data;

      notification.success({
        message: `${"Bienvenue"} ${user.lastname} ${user.firstname} !`,
      });

      await this.authLocalUser();

      return response.data.user;
    } catch (e) {
      console.log(e);
      if (e?.response.data.message !== undefined) {
        notification.error({
          message: e?.response.data.message,
        });
      } else {
        notification.error({
          message: `Ces identifiants ne sont pas corrects`,
        });
      }
    }
  };

  registerNewUser = async (data, token) => {
    try {
      const response = await http.post(`users/confirmCreation/${token}`, data);
      return true;
    } catch (e) {
      return e.response.data.errors.message;
    }
  };

  changeState = (name, value, parent) => {
    if (parent === null) {
      this.setState({ [name]: value });
    } else {
      const parentValue = { ...this.state[parent] };
      parentValue[name] = value;
      this.setState({ [parent]: parentValue });
    }
  };

  logoutUser = async (notif = true) => {
    await localStorage.removeItem(localStorageUserKey);
    delete http.defaults.headers.common.Authorization;
    const userName = renderUserName(this.state.user);
    this.setState({
      ...initialState,
      appReady: true,
    });
    router.navigate("/auth", { replace: true });

    if (notif) {
      notification.success({
        message: "Vous avez été déconnecté",
        description: `Aurevoir ${userName}`,
      });
    }
  };

  state = {
    ...initialState,
    authLocalUser: this.authLocalUser,
    logoutUser: this.logoutUser,
    changeState: this.changeState,
    registerNewUser: this.registerNewUser,
    logUser: this.logUser,
  };

  render() {
    const { children } = this.props;

    return (
      <UserContext.Provider value={this.state}>{children}</UserContext.Provider>
    );
  }
}

export const withUser = Component => props => (
  <UserContext.Consumer>
    {store => <Component user={store} {...props} />}
  </UserContext.Consumer>
);
